<template>
  <div class="overflow-hidden" id="search-page">
    <!--SEARCH-->
    <div class="search-page__search-bar flex items-center">
      <vs-input class="w-full input-rounded-full" icon="icon-search" icon-no-border icon-pack="feather"
                placeholder="Search" v-model="postSearchQuery"/>
    </div>
    <!--FILTER-->
    <div class="search-page__serch-menu flex flex-wrap items-center md:justify-between mt-6 mb-6">
      <div class="flex flex-wrap my-auto">
        <div class="flex justify-end">
          <!--ADD NEW POST-->
          <vs-button @click="addPostActive = !addPostActive;newPost = ''"
                     class="px-4"
                     icon="icon-plus" icon-pack="feather">
            {{ $t('web-board.add-new-post') }}
          </vs-button>
        </div>
      </div>
      <div class="ml-auto">
        <vs-dropdown class="cursor-pointer" vs-trigger-click>
                    <span class="flex items-center">
                        <span>{{timeFilter}}</span>
                        <feather-icon class="cursor-pointer" icon="ChevronDownIcon"
                                      style="width:1rem; height:1rem"></feather-icon>
                    </span>
          <vs-dropdown-menu class="w-48">
            <vs-dropdown-item @click="handleTimeFilter($t('web-board.any-time'))">
              {{ $t('web-board.any-time') }}
            </vs-dropdown-item>
            <vs-dropdown-item @click="handleTimeFilter($t('web-board.past-hour'))">
              {{ $t('web-board.past-hour') }}
            </vs-dropdown-item>
            <vs-dropdown-item @click="handleTimeFilter($t('web-board.past-24-hours'))">
              {{ $t('web-board.past-24-hours') }}
            </vs-dropdown-item>
            <vs-dropdown-item @click="handleTimeFilter($t('web-board.past-week'))">
              {{ $t('web-board.past-week') }}
            </vs-dropdown-item>
            <vs-dropdown-item @click="handleTimeFilter($t('web-board.past-month'))">
              {{ $t('web-board.past-month') }}
            </vs-dropdown-item>
            <vs-dropdown-item @click="handleTimeFilter($t('web-board.past-year'))">
              {{ $t('web-board.past-year') }}
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>

    <!--NEW POST FORM-->
    <transition mode="out-in" name="fade">
      <div class="vx-row px-0 xl:px-5 lg:px-5 md:px-5 sm:px-2" v-if="addPostActive">
        <div class="vx-col w-full" style="padding:10px">
          <p class="font-semibold text-lg mb-2"># {{ $t('web-board.add-you-post') }}</p>
          <vs-textarea @keydown.tab.prevent="tabberNewpost($event)"
                       class="responsive border rounded focus:outline-none focus:shadow-outline"
                       v-model="newPost"></vs-textarea>
          <vs-button :disabled="newPost.length === 0"
                     ref="loadableNewPostButton"
                     id="button-new-post-with-loading"
                     class="relative vs-con-loading__container"
                     @click="onAddNewPostClick"
                     type="relief"
                     icon="icon-edit-2"
                     icon-pack="feather">
            {{ $t('web-board.post') }}
          </vs-button>
        </div>
      </div>
    </transition>

    <!--WEB BOARD CONTENT-->
    <div class="vx-row">
      <div class="vx-col w-full px-0 xl:px-5 lg:px-5 md:px-5 sm:px-2">
        <div id="div-with-loading"
             class="vs-con-loading__container w-full"
             :style="isLoading ? 'height: 200px;':''">
        </div>
      </div>
      <div v-if="!isLoading" class="vx-col w-full px-0 xl:px-5 lg:px-5 md:px-5 sm:px-2">
        <vs-collapse accordion type="margin">
          <vs-collapse-item :key="index" :ref="`post${index}`" class="faq-bg rounded-lg pb-2"
                            @click.native="onCollapseClick(index, webBoard)"
                            v-for="(webBoard, index) in filteredPosts">
            <!-- POST HEADER -->
            <div @click="collapseChange(index)" slot="header">
              <div class="post-header flex justify-between mb-4 px-5">
                <!--POST BY-->
                <div class="flex items-center">
                  <div>
                    <vs-avatar :src="getUserPhoto(webBoard)" class="m-0" size="45px"></vs-avatar>
                  </div>
                  <!-- <div @click="goPost(post.id)" class="ml-4 cursor-pointer">-->
                  <div class="ml-4">
                    <h6>{{ getUserName(webBoard) }}</h6>
                    <small>{{ getUserTime(webBoard) }}</small>
                  </div>
                </div>
                <!--COMMENT QTY-->
                <div class="flex items-center mr-5">
                  <feather-icon class="mr-2" icon="MessageSquareIcon" svgClasses="h-5 w-5"></feather-icon>
                  <span>{{ getWebBoardReplyQty(webBoard) }}</span>
                </div>
              </div>
              <div class="post-content px-5" style="white-space: pre-wrap;word-wrap: break-word;">
                <small v-if="!webBoard.isCollapse && webBoard.topic.length >= 100">
                  {{
                  webBoard.topic.includes(' ') ?
                  webBoard.topic.substr(0, webBoard.topic.lastIndexOf(' ',100)) : webBoard.topic.substr(0, 100)
                  }}
                  ...
                </small>
                <small v-else>{{ webBoard.topic }}</small>
              </div>
            </div>
            <div class="px-5 cursor-default">
              <!-- POST MEADIA CONTENT -->
              <!--<div class="post-media-container mb-6 mt-4" v-if="post.media.length">
                <ul class="flex post-media-list">
                  <li :key="mediaIdex" class="post-media m-1 w-auto mx-auto"
                      v-for="(media, mediaIdex) in post.media.slice(0, 2)">
                    <img :src="media.img" alt="user-upload" class="responsive rounded lg:max-w-md">
                  </li>
                </ul>
                <span class="flex justify-end" v-if="post.media.length > 2">
                          <a class="inline-flex items-center text-sm" href="">
                            <span>{{ $t('web-board.view-all') }}</span>
                            <feather-icon
                            :icon="$vs.rtl ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'"
                            svgClasses="h-4 w-4"></feather-icon></a>
                      </span>
              </div>-->
              <!-- POST ACTION DATA -->
              <div>
                <!--<div class="flex justify-between">
                  <div class="flex items-center">
                    &lt;!&ndash; <div class="flex items-center">
                      <feather-icon class="mr-2" icon="HeartIcon"
                      :svgClasses="{'text-danger fill-current stroke-current': post.isLiked}"
                      @click="clickLike(index)"></feather-icon>
                      <span>{{ post.likes }}</span>
                    </div>
                    <ul v-if="post.usersLiked > 0" class="users-liked user-list ml-3 sm:ml-6">
                        <li v-for="(user, userIndex) in post.usersLiked" :key="userIndex">
                            <vx-tooltip :text="user.name" position="bottom">
                                <vs-avatar :src="user.img" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
                            </vx-tooltip>
                        </li>
                    </ul>
                    <small v-if="post.likes > 5" class="ml-2">+{{ post.likes - 5 }} more</small> &ndash;&gt;
                  </div>
                  <div class="flex items-center">
                    <feather-icon class="mr-2" icon="MessageSquareIcon" svgClasses="h-5 w-5"></feather-icon>
                    <span>{{ getWebBoardReplyQty(webBoard) }}</span>
                  </div>
                </div>-->
                <div class="comments-container mt-4">
                  <ul class="user-comments-list">
                    <li
                      :key="webBoardReplyIndex"
                      class="commented-user items-center mb-4"
                      v-for="(webBoardReply, webBoardReplyIndex) in webBoard.webBoardReplies.slice(webBoard.webBoardReplies.length >= 2 ? webBoard.webBoardReplies.length - initialComment : 0, webBoard.webBoardReplies.length)">
                      <div class="flex-none sm:flex md:flex lg:flex xl:flex mt-8">
                        <div class="mr-3 mb-auto float-left">
                          <vs-avatar :src="getUserPhoto(webBoardReply)" class="m-0" size="30px"/>
                        </div>
                        <div class="leading-tight mb-auto flex-none">
                          <span class="font-medium cursor-pointer">{{ getUserName(webBoardReply) }}</span>
                        </div>
                        <div class="mb-auto ml-auto leading-tight flex-none">
                          <!-- <div class="flex">
                              <feather-icon icon="HeartIcon" svgClasses="h-4 w-4" class="mr-2 cursor-pointer"></feather-icon>
                              <feather-icon icon="MessageSquareIcon" svgClasses="h-4 w-4" class="cursor-pointer"></feather-icon>
                          </div> -->
                          <p class="text-xs">{{ getUserTime(webBoardReply) }}</p>
                        </div>
                      </div>
                      <div class="mt-2" style="white-space: pre-wrap;word-wrap: break-word;">
                        <p class="text-sm ml-auto" style="white-space: pre-wrap;word-wrap: break-word;">
                          {{ webBoardReply.replyMessage }}</p>
                      </div>
                    </li>
                  </ul>
                  <div class="flex w-full justify-between">
                    <span class="flex justify-start" v-if="getWebBoardReplyQty(webBoard) > 2">
                      <a @click="onMoreCommentsClick(index)"
                         class="inline-flex items-center text-sm"
                         v-if="initialComment !== getWebBoardReplyQty(webBoard)"><span
                        class="p-2 cursor-pointer px-0">{{ $t('web-board.view-more') }}</span></a>
                      <a @click="onLessCommentClick" class="inline-flex items-center text-sm" v-else>
                        <span class="p-2 cursor-pointer px-1">{{ $t('web-board.view-less') }}</span>
                      </a>
                    </span>
                  </div>
                </div>
                <div class="post-comment">
                  <vs-textarea :label="$t('web-board.add-comment')"
                               @keydown.tab.prevent="tabber($event,index)"
                               class="mb-2" v-if="webBoard.commentBox !== undefined" v-model="webBoard.commentBox"/>
                  <vs-button :disabled="webBoard.commentBox.length === 0"
                             :id="`button-new-comment-with-loading_${index}`"
                             class="vs-con-loading__container"
                             @click="onPostCommentClick(index)"
                             type="relief"
                             icon="icon-edit-2"
                             icon-pack="feather"
                             size="small">
                    {{ $t('web-board.comment') }}
                  </vs-button>
                </div>
              </div>
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import store from '../../../../../store';
  import {createHelpers} from 'vuex-map-fields';
  import {createNamespacedHelpers} from "vuex";
  import WebBoard from '../../../../../store/modules/web-board/index';
  import WebBoardReply from '../../../../../store/modules/web-board-reply/index';
  import {getAvatarUrl} from "../../../../../utils/upload";
  import {dateTimeFormat} from "../../../../../utils/format";
  import {displayTeacherName, displayStudentName} from "@/utils/name";

  if (!store.state.WebBoard) store.state.registerModule(`WebBoard`, WebBoard);
  if (!store.state.WebBoardReply) store.state.registerModule(`WebBoardReply`, WebBoardReply);

  const {
    mapActions: mapWebBoardActions,
  } = createNamespacedHelpers(`WebBoard`);
  const {
    mapActions: mapWebBoardReplyActions,
  } = createNamespacedHelpers(`WebBoardReply`);

  const {
    mapFields: mapWebBoardFields,
  } = createHelpers({
    getterType: `WebBoard/getField`,
    mutationType: `WebBoard/updateField`,
  });

  export default {
    props: [
      'classSection',
    ],
    data() {
      return {
        webBoards: [],
        searchQuery: '',
        newPost: '',
        initialComment: 2,
        addPostActive: false,
        isNavOpen: false,
        timeFilter: this.$t('web-board.any-time'),
        selectType: '',
        postSearchQuery: '',
        connection: null,
        number: null,
        timeStamp: null,
        Time: null,
        moment: moment,
        isLoading: false,
        backgroundLoading:'primary',
        colorLoading:'#fff',
        filteredPostsTime: [],

      }
    },
    computed: {
      ...mapWebBoardFields({
        webBoardProcessing: 'processing',
        webBoardError: 'error',
        webBoardSuccess: 'success'
      }),
      filteredPosts() {
        if (this.webBoards && this.webBoards.length) {
          return this.webBoards.filter((post) => {
            return post.topic.toLowerCase().includes(
              this.postSearchQuery.toLowerCase())
              && this.webBoards.includes(post)
              && this.filteredPostsTime.includes(post)
          });
        } else {
          return [];
        }
      }
    },
    watch:{
      isLoading(val){
        if(val){
          this.$vs.loading({
            container: '#div-with-loading',
            scale: 1
          })
        }else{
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
        }
      }
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapWebBoardActions({
        getWebBoardsByFilter: 'getWebBoardsByFilter',
        addWebBoard: 'addWebBoard',
        updateReplyToWebBoard: 'updateReplyToWebBoard',
        updateWebBoardAlreadyRead: 'updateWebBoardAlreadyRead',
        updateWebBoardHitCount: 'updateWebBoardHitCount',
      }),
      ...mapWebBoardReplyActions({
        addWebBoardReply: 'addWebBoardReply',
        updateWebBoardReply: 'updateWebBoardReply',
        deleteWebBoardReply: 'deleteWebBoardReply',
      }),
      onMoreCommentsClick(index) {
        const commentLength = this.filteredPosts[index].webBoardReplies.length
        let minus = 5
        if (this.initialComment + minus >= commentLength) {
          minus = commentLength - this.initialComment
        }
        this.initialComment += minus
      },
      onLessCommentClick() {
        this.initialComment = 2;
      },
      async onAddNewPostClick() {
        const buttonId = "#button-new-post-with-loading";
        this.startLoadingButton(buttonId);

        const payload = {
          courseOutlineRegistrationId: this.classSection.courseOutlineRegistration.id,
          classSectionId: this.classSection.id,
          academicPeriodId: this.classSection.courseOutlineRegistration.academicPeriod.id,
          postBy: 'teacher',
          webBoardInput: {
            sectionNo: this.classSection.sectionNo,
            topic: this.newPost,
            hasNewReply: false,
          }
        }
        let result = await this.addWebBoard(payload);
        if (result) {
          result = JSON.parse(JSON.stringify(result));
          this.webBoards.unshift({
            ...result,
            commentBox: '',
          });
          this.handleTimeFilter(this.$t('web-board.any-time'));
        }

        this.addPostActive = false
        this.newPost = ''
        this.stopLoadingButton(buttonId);
      },
      async onPostCommentClick(index) {
        const buttonId = `#button-new-comment-with-loading_${index}`;
        this.startLoadingButton(buttonId);
        const payload = {
          webBoardId: this.webBoards[index].id,
          postBy: 'teacher',
          webBoardReplyInput: {
            replyMessage: this.webBoards[index].commentBox,
          }
        };
        let result = await this.addWebBoardReply(payload);
        if (result) {
          result = JSON.parse(JSON.stringify(result));
          this.webBoards[index].commentBox = '';
          this.webBoards[index].webBoardReplies.push(result);
        }
        this.stopLoadingButton(buttonId);
      },
      async onCollapseClick(index, webBoard){
        const isActive = this.checkActiveCollapse(index);
        if(isActive){
          const payload = {
            id: webBoard.id,
          };
          //update hit rate
          await this.updateWebBoardHitCount(payload);
          if(webBoard.hasNewReply){
            //update has new reply to false
            await this.updateWebBoardAlreadyRead(payload);
          }
        }
      },
      handleTimeFilter(time) {
        let subtractTime = null
        this.timeFilter = time;
        let now = moment();
        switch (time) {
          case this.$t('web-board.any-time'):
            subtractTime = this.moment.duration(1000,'y')
            break;
          case this.$t('web-board.past-hour'):
            subtractTime = this.moment.duration(1,'h')
            break;
          case this.$t('web-board.past-24-hours'):
            subtractTime = this.moment.duration(24,'h')
            break;
          case this.$t('web-board.past-week'):
            subtractTime = this.moment.duration(1,'w')
            break;
          case this.$t('web-board.past-month'):
            subtractTime = this.moment.duration(1,'M')
            break;
          case this.$t('web-board.past-year'):
            subtractTime = this.moment.duration(1,'y')
            break;
        }
        this.filteredPostsTime = this.webBoards.filter(value => {
          return new Date(value.updatedAt) >= now.subtract(subtractTime)
        })
      },
      tabberNewpost(event) {
        if (event) {
          event.preventDefault()
          let startText = this.newPost.slice(0, event.target.selectionStart)
          let endText = this.newPost.slice(event.target.selectionStart)
          this.newPost = `${startText}\t${endText}`
          event.target.selectionEnd = event.target.selectionStart + 1
        }
      },
      tabber(event, index) {
        if (event) {
          event.preventDefault()
          let startText = this.webBoards[index].commentBox.slice(0, event.target.selectionStart)
          let endText = this.webBoards[index].commentBox.slice(event.target.selectionStart)
          this.webBoards[index].commentBox = `${startText}\t${endText}`
          event.target.selectionEnd = event.target.selectionStart + 1
        }
      },
      goPost(id) {
        this.$router.push(`/post/${id}`)
      },
      collapseChange(index) {
        this.webBoards[index].isCollapse = !this.webBoards[index].isCollapse
        this.initialComment = 2
      },
      checkActiveCollapse(index) {
        return this.$refs[`post${index}`][0].$el.classList.contains('open-item')
      },
      async loadData() {
        const payload = {
          webBoardFilterInput: {
            classSectionId: this.classSection.id,
          },
        };
        await this.filterData(payload);
      },
      async filterData(payload) {
        this.isLoading = true;
        let result = await this.getWebBoardsByFilter(payload);
        if (result && result.length > 0) {
          result = JSON.parse(JSON.stringify(result));
          this.webBoards = result.map(item => {
            return {
              ...item,
              commentBox: '',
            };
          });
          this.handleTimeFilter(this.$t('web-board.any-time'));
        }
        this.isLoading = false;
      },
      getUserPhoto(webBoardOrWebBoardReply) {
        if (webBoardOrWebBoardReply) {
          if (webBoardOrWebBoardReply.teacher) {
            return getAvatarUrl(webBoardOrWebBoardReply.teacher.picturePath)
          } else if (webBoardOrWebBoardReply.student) {
            return getAvatarUrl(webBoardOrWebBoardReply.student.picturePath)
          }
        }
        return getAvatarUrl('');
      },
      getUserName(webBoardOrWebBoardReply) {
        if (webBoardOrWebBoardReply) {
          if (webBoardOrWebBoardReply.teacher) {
            return displayTeacherName(webBoardOrWebBoardReply.teacher)
          } else if (webBoardOrWebBoardReply.student) {
            return displayStudentName(webBoardOrWebBoardReply.student)
          }
        }
        return '';
      },
      getUserTime(webBoardOrWebBoardReply) {
        if (webBoardOrWebBoardReply) {
          return moment(webBoardOrWebBoardReply.updatedAt).format(dateTimeFormat.momentYYYYMMDDhhmmss);
        }
        return '-';
      },
      getWebBoardReplyQty(webBoard) {
        if (webBoard && webBoard.webBoardReplies) {
          return webBoard.webBoardReplies.length
        }
        return 0;
      },
      startLoadingButton(id){
        this.$vs.loading({
          background: this.backgroundLoading,
          color: this.colorLoading,
          container: id,
          scale: 0.45
        })
      },
      stopLoadingButton(id){
        this.$vs.loading.close(`${id} > .con-vs-loading`);
      },
    },
    created() {
      localStorage.setItem('Webboard', JSON.stringify({
        searchQuery: '',
        newPost: '',
        initialComment: 2,
        addPostActive: false,
        isNavOpen: false,
        user_info: {
          profile_img: '/static/images/avatar.png',
          cover_img: '/static/images/avatar.png'
        },
        userLatestPhotos: [
          '/static/images/avatar.png'
        ],
        userPosts: [
          {
            id: 1,
            author: 'Leeanna Alvord',
            time: 'May 2, 2020 10:30 AM',
            isLiked: true,
            isCollapse: false,
            text: 'I love jujubes wafer pie ice cream tiramisu. Chocolate I love pastry pastry sesame snaps wafer. Pastry topping biscuit lollipop topping I love lemon drops sweet roll bonbon. Brownie donut icing.',
            media: [{img: '/static/images/classroom-placeholder.jpg'}],
            likes: 145,
            comments: 10,
            usersLiked: [
              {name: 'Trina Lynes', img: '/static/images/avatar.png'},
              {name: 'Lilian Nenez', img: '/static/images/avatar.png'},
              {name: 'Alberto Glotzbach', img: '/static/images/avatar.png'},
              {name: 'George Nordick', img: '/static/images/avatar.png'},
              {name: 'Vennie Mostowy', img: '/static/images/avatar.png'}
            ],
            commentBox: '',
            usersCommented: [
              {
                comment: 'Comment 1',
                author: 'Kitty Allanson',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:56:05 GMT+0000 (GMT)'
              },
              {
                comment: 'Comment 2',
                author: 'Jeanie Bulgrin',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:55:00 GMT+0000 (GMT)'
              },
              {
                comment: 'Comment 3',
                author: 'Jeanie Bulgrin',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:55:00 GMT+0000 (GMT)'
              },
              {
                comment: 'Comment 4',
                author: 'Jeanie Bulgrin',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:55:00 GMT+0000 (GMT)'
              },
              {
                comment: 'Comment 5',
                author: 'Jeanie Bulgrin',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:55:00 GMT+0000 (GMT)'
              },
              {
                comment: 'Comment 6',
                author: 'Jeanie Bulgrin',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:55:00 GMT+0000 (GMT)'
              },
              {
                comment: 'Comment 7',
                author: 'Jeanie Bulgrin',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:55:00 GMT+0000 (GMT)'
              },
              {
                comment: 'Comment 8',
                author: 'Jeanie Bulgrin',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:55:00 GMT+0000 (GMT)'
              },
              {
                comment: 'Comment 9',
                author: 'Jeanie Bulgrin',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:55:00 GMT+0000 (GMT)'
              },
              {
                comment: 'Comment 10 <br/> asdasd',
                author: 'Jeanie Bulgrin',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:55:00 GMT+0000 (GMT)'
              }
            ]
          },
          {
            id: 2,
            author: 'Leeanna Alvord',
            time: 'May 26, 2019 10:30 AM',
            isLiked: false,
            isCollapse: false,
            text: 'Candy jelly beans powder brownie biscuit. Jelly marzipan oat cake cake. Cupcake I love wafer cake. Halvah I love powder jelly I love cheesecake cotton candy tiramisu brownie.',
            media: [{img: '/static/images/classroom-placeholder.jpg'}],
            likes: 276,
            comments: 9,
            usersLiked: [
              {name: 'Lai Lewandowski', img: '/static/images/avatar.png'},
              {name: 'Elicia Rieske', img: '/static/images/avatar.png'},
              {name: 'Darcey Nooner', img: '/static/images/avatar.png'},
              {name: 'Julee Rossignol', img: '/static/images/avatar.png'},
              {name: 'Jeffrey Gerondale', img: '/static/images/avatar.png'}
            ],
            commentBox: '',
            usersCommented: [
              {
                comment: 'Comment 1.1',
                author: 'Kitty Allanson',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:56:05 GMT+0000 (GMT)'
              },
              {
                comment: 'Comment 1.2',
                author: 'Jeanie Bulgrin',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:55:00 GMT+0000 (GMT)'
              },
              {
                comment: 'Comment 1.3',
                author: 'Jeanie Bulgrin',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:55:00 GMT+0000 (GMT)'
              },
              {
                comment: 'Comment 1.4',
                author: 'Jeanie Bulgrin',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:55:00 GMT+0000 (GMT)'
              },
              {
                comment: 'Comment 1.5',
                author: 'Jeanie Bulgrin',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:55:00 GMT+0000 (GMT)'
              },
              {
                comment: 'Comment 1.6',
                author: 'Jeanie Bulgrin',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:55:00 GMT+0000 (GMT)'
              },
              {
                comment: 'Comment 1.7',
                author: 'Jeanie Bulgrin',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:55:00 GMT+0000 (GMT)'
              },
              {
                comment: 'Comment 1.8',
                author: 'Jeanie Bulgrin',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:55:00 GMT+0000 (GMT)'
              },
              {
                comment: 'Comment 1.9',
                author: 'Jeanie Bulgrin',
                img: '/static/images/avatar.png',
                time: 'Mon Dec 10 2018 08:55:00 GMT+0000 (GMT)'
              }
            ]
          }
        ],
        wasSidebarOpen: null
      }))
    },
    async beforeMount() {
      await this.loadData();
    },
  }
</script>

<style lang="scss">
  @import "@/assets/scss/vuexy/pages/search.scss";

  .vs-collapse-item.open-item .vs-collapse-item--content {
    max-height: min-content !important;
  }

  .vs-icon {
    font-size: x-large;
  }

  .fade-enter-active {
    transition: all .3s ease;
  }

  .fade-leave-active {
    transition: all .3s ease;
  }

  .fade-enter, .fade-leave-to {
    transform: translateY(-50px);
    opacity: 0;
  }
</style>
